var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.62 29.248c3.784 0 7.492-1.59 10.066-4.466.075-.151.151-.302.227-.378-.076-.227-.152-.379-.303-.454l-1.59-1.06c-.15-.076-.302-.151-.454-.151a.86.86 0 0 0-.605.226c-1.967 1.968-4.54 3.027-7.265 3.027-.454 0-.833 0-1.211-.075-4.693-.53-8.477-4.315-9.007-9.007a10.01 10.01 0 0 1 2.498-8.022 10.11 10.11 0 0 1 7.644-3.482 10.2 10.2 0 0 1 5.827 1.816c.076.076.303.152.454.152a.86.86 0 0 0 .607-.227l1.438-1.287a.687.687 0 0 0 .227-.53c0-.151-.076-.378-.227-.454A13.394 13.394 0 0 0 15.619 2c-.53 0-1.06 0-1.59.076C7.748 2.833 2.752 7.828 2.07 14.11c-.377 3.936.758 7.645 3.407 10.596a13.655 13.655 0 0 0 10.142 4.542zm7.72-18.392c0 1.816 1.513 3.33 3.33 3.33 1.816 0 3.33-1.514 3.33-3.33 0-1.817-1.514-3.33-3.33-3.33-1.817 0-3.33 1.513-3.33 3.33z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCel);
export default __webpack_public_path__ + "static/media/CEL.d0a9664bad85405f26aff4c12a39cb9b.svg";
export { ForwardRef as ReactComponent };